<template>
    <div v-if="loggedIn">
        <ExternalUserActionRecommendation />
    </div>
</template>
<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {useAuth} from '#imports';
    import ExternalUserActionRecommendation from '~/components/external-user-action/recommendations/ExternalUserActionRecommendation.vue';

    // Stores
    const {loggedIn} = storeToRefs(useAuth());
</script>
